import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface MfaStatus {
  enabled: boolean;
}

export interface MfaSetup {
  secret: string;
  otpauthUrl: string;
  qrDataUrl: string;
}

export function useMfaStatus() {
  return useQuery({
    queryKey: ['auth', 'mfa'],
    queryFn: () => api.get<MfaStatus>('/v1/auth/mfa'),
  });
}

export function useMfaSetup() {
  return useMutation({
    mutationFn: () => api.post<MfaSetup>('/v1/auth/mfa/setup'),
  });
}

export function useMfaEnable() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { secret: string; code: string }) =>
      api.post<{ ok: boolean }>('/v1/auth/mfa/enable', input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['auth', 'mfa'] });
    },
  });
}

export function useMfaDisable() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { code: string }) =>
      api.post<{ ok: boolean }>('/v1/auth/mfa/disable', input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['auth', 'mfa'] });
    },
  });
}
